import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ErrorData {
  id?: number;
  [key: string]: any;
}

interface GlobalErrorState {
  error: ErrorData | null;
}

const initialState: GlobalErrorState = { error: null };

const name = "globalErrors";
const globalErrorsSlice = createSlice({
  initialState,
  name,
  reducers: {
    clearError: (state, action: PayloadAction<number>) => {
      if (action.payload === state.error?.id) state.error = null;
    },
    get: (state, action: PayloadAction<any>) => {
      state.error = { ...action.payload, id: new Date().getTime() };
    },
  },
});

export default globalErrorsSlice.reducer;
export const { clearError: onClearError } = globalErrorsSlice.actions;
